import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter } from "react-router-dom";

import reportWebVitals from './reportWebVitals';
import store from './store/store';

import './index.scss';
import App from './App';



ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <HashRouter basename="/page">
        <App />
      </HashRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


